// Framework
import * as Api from 'api/login';
import { call, put } from 'redux-saga/effects';
import { loginSuccess } from 'actions/auth/login';
import { push } from 'react-router-redux';
import { pushFormattedError } from 'helpers/formValidationHelper/formValidationMessage';

/*** Sagas ***/
//ssoWorker
export function* setAuthTokenWorker({ lang, client, token, ...redirects }) {
  try {
    const authToken = `Bearer ${token}`;
    const { data: userInfo, permissions } = yield call(Api.me, lang, authToken);
    const { menu } = yield call(Api.getSideMenu, lang, authToken);
    yield put(
      loginSuccess({ authToken, ...userInfo, permissions, client, menu })
    );

    const path = Object.values(redirects).join('/');
    yield put(push(`/${lang}/${client}/${path}`));
  } catch (err) {
    //TODO: refactor to only 1
    yield pushFormattedError(err);
    yield put(push(`/${lang}/${client}/login`));
  }
}



// WEBPACK FOOTER //
// ./src/actions/auth/sso.js